import { Link } from 'react-router-dom'
import {
  PiCaretLeft,
  PiChartBar,
  PiSquaresFour,
  PiTarget,
} from 'react-icons/pi'
import { REPORTING_PAGE_SHELL } from './page-shell'

const FORKS = [
  {
    to: '/reporting/new/report',
    icon: <PiChartBar size={32} />,
    title: 'Report',
    description: 'Analyze your data with tables, charts, and metrics.',
  },
  {
    to: '/reporting/dashboards/new',
    icon: <PiSquaresFour size={32} />,
    title: 'Dashboard',
    description: 'Combine reports into a visual overview.',
  },
  {
    to: '/reporting/new/goal',
    icon: <PiTarget size={32} />,
    title: 'Goal',
    description: 'Set a target to track against your reports.',
  },
]

export default function BuildForkPage() {
  return (
    <div className={REPORTING_PAGE_SHELL}>
      <div>
        <Link
          to="/reporting"
          className="inline-flex items-center gap-1 text-sm text-fg-secondary hover:text-fg"
        >
          <PiCaretLeft size={14} /> Reports
        </Link>
        <h1 className="mt-2 text-2xl font-bold text-fg">
          What do you want to build?
        </h1>
      </div>

      <div className="grid grid-cols-3 gap-4">
        {FORKS.map((f) => (
          <Link
            key={f.to}
            to={f.to}
            className="flex flex-col gap-3 rounded-2xl border-2 border-line bg-surface p-6 transition-all hover:border-brand-active/40 hover:bg-surface-hover"
          >
            <span className="text-fg-secondary">{f.icon}</span>
            <div>
              <p className="text-lg font-semibold text-fg">{f.title}</p>
              <p className="mt-1 text-sm text-fg-secondary">{f.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}
